import React from "react";
import PageWrapper from "./PageHelpers/PageWrapper";
import { useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import isLoading from "../../lib/functions/isLoading";
import ResultsListLoading from "./ResultsList/ResultsListLoading";
import ResultsListReady from "./ResultsList/ResultsListReady";
import { useResultsRequest } from "../hooks/useResultsRequest";
import ResultsPrintButton from "./ResultsList/ResultsPrintButton";
import ResultsCopyClipboardButton from "./ResultsList/ResultsCopyClipboardButton";
import { useDocumentTitle } from "../../lib/a11y/useDocumentTitle";
import { useFocusHeading } from "../../lib/a11y/useFocusHeading";

const PageResults = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const results = useSelector((state) => state.results);
  const matrixName = useSelector((state) => state.questionnaire.name);

  useResultsRequest(searchParams);

  const loading = isLoading(results.status, "Results Error: " + results.error);

  // Titel und Fokus je Zustand (#178): der Screenreader hoert den Wechsel auf
  // die Ergebnisseite, sobald die Rangliste steht.
  useDocumentTitle(`Dein Ergebnis – ${matrixName}`);
  const headingRef = useFocusHeading(!loading);

  return (
    <PageWrapper className="page-results" displayFooter={true} headingRef={headingRef}>
      {loading ? (
        <ResultsListLoading />
      ) : (
        <>
          <ResultsListReady results={results.results} />

          <p className="datenshutz">
            Aus Datenschutz- und Anonymisierungsgründen bitten wir Sie, die
            obenstehende URL dieser Seite zu kopieren und abzuspeichern. Auf
            diese Weise kann das Ergebnis jederzeit erneut aufgerufen werden,
            ohne dass dabei Nutzerdaten erfasst werden.
          </p>

          <div className="jm-btns-container">
            <Link className="jm-action-button jm-start-button jm-arrow-right" to="/">
              Erneut starten
            </Link>

            <ResultsCopyClipboardButton />

            <ResultsPrintButton />
          </div>
        </>
      )}
    </PageWrapper>
  );
};

export default PageResults;
